import React, { FC, memo } from 'react';
import { useIntl } from 'umi';
import { BubbleProps } from 'tea-component';
import CommonBubble from '@home/components/CommonBubble';
import SvgIcon from '@home/components/SvgIcon';
import { LANGUAGE_EN } from '@home/_config/config';

import './index.scss';

/** portal overlay class，供浮窗外点关闭白名单 */
export const CHART_TITLE_TIP_OVERLAY_CLASS = 'dba-new-chart-title-tip';

const PREFIX = 'dba-new-chart-popover-title-tip';

interface IChartPopoverTitleTipProps
  extends Pick<
  BubbleProps,
  | 'placement'
  | 'placementOffset'
  | 'escapeWithReference'
  | 'flipped'
  | 'dark'
  | 'arrowPointAtCenter'
  | 'visible'
  | 'onVisibleChange'
  > {
  /** 自定义 tooltip 内容，默认使用 dba_new_chart_select_title_tips */
  content?: React.ReactNode;
  overlayClassName?: string;
}

/** 「选择页面或图表」标题旁 ? 说明（英文按单词换行，中文单行） */
const ChartPopoverTitleTip: FC<IChartPopoverTitleTipProps> = ({
  content: customContent,
  overlayClassName: extraOverlayClass,
  ...restProps
}) => {
  const { formatMessage, locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;

  const tipContent = customContent ?? (
    isEN
      ? formatMessage({ id: 'dba_new_chart_select_title_tips' })
      : <span className={`${PREFIX}__text`}>{formatMessage({ id: 'dba_new_chart_select_title_tips' })}</span>
  );

  // 合并默认 overlayClassName
  const mergedOverlayClassName = [
    'dba-nav-menu-overlay',
    CHART_TITLE_TIP_OVERLAY_CLASS,
    isEN ? '' : `${CHART_TITLE_TIP_OVERLAY_CLASS}--cn`,
    extraOverlayClass,
  ].filter(Boolean).join(' ');

  return (
    <CommonBubble
      dark
      arrowPointAtCenter
      placement="top"
      placementOffset={8}
      overlayClassName={mergedOverlayClassName}
      escapeWithReference
      flipped={false}
      content={tipContent}
      {...restProps}
    >
      <span className={PREFIX}>
        <SvgIcon type="alert-circle-m" className={`${PREFIX}__icon`} />
        <SvgIcon
          type="alert-circle-action"
          className={`${PREFIX}__icon ${PREFIX}__icon--hover`}
        />
      </span>
    </CommonBubble>
  );
};

export default memo(ChartPopoverTitleTip);
